import { useState } from "react";
import { ReactSVG } from "react-svg";

const SelectUserTypeCom = ({
  cateCardtitle,
  cateCardImg,
  selectedcateCardImg,
  onSelect,
}) => {
  const [isSelected, setIsSelected] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const handleSelect = () => {
    setIsSelected(!isSelected);
    onSelect();
  };
  return (
    <div
      className={`relative cursor-pointer flex justify-center items-center flex-col py-1.5 sm:py-2 lg:py-3 ${
        isHovered
          ? "text-secondary rounded-3xl bg-primary after:border-none transition duration-300 ease-in-out"
          : "after:rounded-3xl after:border-2 after:w-full after:h-full after:absolute after:top-0 after:left-0 border-[#8D8D8D] bg-secondary text-customBlack"
      }`}
      onClick={handleSelect}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div>
        <ReactSVG
          src={isHovered ? selectedcateCardImg : cateCardImg}
          beforeInjection={(svg) => {
            svg.classList.add(
              "w-10",
              "h-10",
              "sm:w-9",
              "sm:h-10",
              "lg:w-12",
              "lg:h-14",
              "2xl:w-14",
              "2xl:h-16",
              "h-auto"
            );
          }}
        />
      </div>
      <div
        className={`text-center z-20 text-sm  lg:text-base font-ralewaySemiBold 2xl:text-xl pt-1`}
      >
        {cateCardtitle}
      </div>
    </div>
  );
};

export default SelectUserTypeCom;
